import React from 'react';

type ToggleList2IconProps = {
  className?: string;
};

const ToggleList2Icon = ({ className }: ToggleList2IconProps) => {
  return (
    <svg fill="none" height="24" viewBox="0 0 24 24" width="24" xmlns="http://www.w3.org/2000/svg">
      <path
        clip-rule="evenodd"
        d="M10.082 7.20833C10.082 6.67906 10.5111 6.25 11.0404 6.25H19.6654C20.1946 6.25 20.6237 6.67906 20.6237 7.20833C20.6237 7.73761 20.1946 8.16667 19.6654 8.16667H11.0404C10.5111 8.16667 10.082 7.73761 10.082 7.20833ZM10.082 12C10.082 11.4707 10.5111 11.0417 11.0404 11.0417H19.6654C20.1946 11.0417 20.6237 11.4707 20.6237 12C20.6237 12.5293 20.1946 12.9583 19.6654 12.9583H11.0404C10.5111 12.9583 10.082 12.5293 10.082 12ZM11.0404 15.8333C10.5111 15.8333 10.082 16.2624 10.082 16.7917C10.082 17.3209 10.5111 17.75 11.0404 17.75H19.6654C20.1946 17.75 20.6237 17.3209 20.6237 16.7917C20.6237 16.2624 20.1946 15.8333 19.6654 15.8333H11.0404Z"
        fill="#888888"
        fill-rule="evenodd"
      />
      <path
        clip-rule="evenodd"
        d="M8.49746 6.81601C8.8446 7.16315 8.8446 7.72596 8.49746 8.07309L6.49746 10.0731C6.15033 10.4202 5.58752 10.4202 5.24038 10.0731L3.24038 8.07309C2.89325 7.72596 2.89325 7.16315 3.24038 6.81601C3.58752 6.46888 4.15033 6.46888 4.49746 6.81601L5.86892 8.18747L7.24038 6.81601C7.58752 6.46888 8.15033 6.46888 8.49746 6.81601Z"
        fill="#888888"
        fill-rule="evenodd"
      />
      <path
        clip-rule="evenodd"
        d="M3.24082 17.184C2.89369 16.8369 2.89369 16.274 3.24082 15.9269L5.24082 13.9269C5.58795 13.5798 6.15076 13.5798 6.4979 13.9269L8.4979 15.9269C8.84503 16.274 8.84503 16.8369 8.4979 17.184C8.15076 17.5311 7.58795 17.5311 7.24082 17.184L5.86936 15.8125L4.4979 17.184C4.15076 17.5311 3.58795 17.5311 3.24082 17.184Z"
        fill="#888888"
        fill-rule="evenodd"
      />
    </svg>
  );
};

export default React.memo(ToggleList2Icon);
